var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderIcon } from '../../utils/icon-utils';
import * as styles from './icon-wrapper.styles';
export var IconWrapper = function (_a) {
    var icon = _a.icon, iconBorderColor = _a.iconBorderColor, iconColor = _a.iconColor, className = _a.className, iconSize = _a.iconSize;
    return (_jsxs("div", __assign({ className: styles.wrapperContainer }, { children: [_jsx("div", { className: styles.iconWrapper(iconBorderColor), "data-testid": "icon-wrapper" }), _jsx("div", __assign({ className: styles.iconContainer }, { children: renderIcon(icon, "z-20 w-".concat(iconSize !== null && iconSize !== void 0 ? iconSize : 6, " h-").concat(iconSize !== null && iconSize !== void 0 ? iconSize : 6, " text-").concat(iconColor)) }))] })));
};
//# sourceMappingURL=icon-wrapper.js.map